















































































































































































































































































import mixins from 'vue-typed-mixins'
import facturationMixin from './facturationsMixin'
import Facturation from './models/facturation'
//@ts-ignore
import CKEditor from '@ckeditor/ckeditor5-vue2'
//@ts-ignore
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { DemandeFacturation } from '@/domain/DemandeFacturation'
import { TraitementReeditionFacture_Statut, TraitementReeditionFacture_Statut_ToText } from '@/domain/TraitementReeditionFacture_Statut'
import _ from 'lodash'
import { RoleEnum } from '@/domain/role'
import Openable from '@/global/viewmodels/openable'
import SendReeditionFactureModel from './models/sendReeditionFactureModel'

export default mixins(facturationMixin).extend({
    components: {
        DialogReedition: () => import('./components/DialogReedition.vue'),
        // DialogMailFacturation: () => import('./components/DialogMailFacturation.vue'),
        DialogMail: () => import('../../layout/components/DialogMail.vue'),
    },
    data() {
        return {
            dialog: new Openable(),
            dialogMail: new Openable(),

            selectedCode: null as string | null,
            tab: 'en-cours-facturation',
            editor: ClassicEditor,
            editorConfig: {
                toolbar: {
                    items: ['bold', 'italic', 'link', 'undo', 'redo', 'numberedList', 'bulletedList'],
                    shouldNotGroupWhenFull: true,
                },
            },
            nav: 'tab-suivi',
            expandedDemandesFacturations: [] as DemandeFacturation[],
            mailReeditionFacture: new SendReeditionFactureModel(),
        }
    },
    computed: {
        totalEcheance(): number {
            return this.filteredFacturation.filter((facture) => !facture.paid && facture.echeancePassee).sum((f) => f.amount)
        },
        totalImpayeesPasEcheance(): number {
            return this.filteredFacturation.filter((facture) => !facture.paid && !facture.echeancePassee).sum((f) => f.amount)
        },
        filteredCode(): Array<string> {
            this.selectedCode = null
            return this.facturations.map((x) => x.code).distinct()
        },
        filteredEnCoursFacturation(): Array<Facturation> {
            return this.filteredFacturation.filter((facture) => !facture.paid)
        },
        filteredFacturation(): Array<Facturation> {
            return this.selectedCode ? this.facturations.filter((x) => x.code == this.selectedCode) : this.facturations
        },
    },
    methods: {
        // Méthodes de dialogs
        openReedition() {
            this.dialog.open()
        },
        openEnvoiMail(demande: DemandeFacturation) {
            // this.modalEnvoiMailDemandeReeditionFacture(demande) // OLD version

            this.mailReeditionFacture = new SendReeditionFactureModel()
            this.mailReeditionFacture.id = demande.id
            this.mailReeditionFacture.mail = demande.emailDestinataire;
            this.mailReeditionFacture.corps = "Bonjour,\n\n" +
                "Je vous prie de trouver ci-joint la / les factures(s) demandée(s).\n\n" +
                "Nous restons à votre disposition pour tout complément d’information,\n\n" +
                "Bien cordialement,"
            this.dialogMail.open()
        },

        isExpanded(item: DemandeFacturation) {
            return _.some(this.expandedDemandesFacturations, (i) => i.id == item.id)
        },
        expandDemandeFacturation(item: DemandeFacturation) {
            const obj = _.find(this.expandedDemandesFacturations, (i) => i.id == item.id)
            if (!obj) {
                return this.expandedDemandesFacturations.push(item)
            }

            const index = this.expandedDemandesFacturations.indexOf(obj)
            this.expandedDemandesFacturations.splice(index, 1)
        },
        paidColor(paid: boolean) {
            return paid ? 'success' : 'error'
        },
        paidSymbol(value: boolean) {
            return value ? 'mdi-check' : 'mdi-close'
        },
        paidClass(amount: number) {
            return amount >= 0 ? 'amount-positive' : 'amount-negative'
        },
        cardBorder(amount: number) {
            return amount >= 0 ? 'border:5px double #83b33f' : 'border:5px double #b71c1c'
        },
        onCompanyChange() {
            if (this.selectedCompany) this.loadFacturation(this.facturations, this.selectedCompany)
        },
        headers() {
            const headers = this.isMobileDevice()
                ? [
                      { text: '', value: 'data-table-expand', align: 'start' },
                      { text: 'Réglé', value: 'paid' },
                      { text: "Date d'émission", value: 'date' },
                  ]
                : [
                      { text: '', value: 'data-table-expand', align: 'start' },
                      { text: 'Réglé', value: 'paid' },
                      { text: 'Numéro', value: 'code' },
                      { text: "Date d'émission", value: 'date' },
                  ]
            if (this.$database.account.roleEnum != RoleEnum.Client) headers.push({ text: 'Montant', value: 'amount' })

            return headers
        },
        headersEnCours() {
            const headers = this.isMobileDevice()
                ? [
                      { text: '', value: 'data-table-select', width: '1%' },
                      { text: '', value: 'data-table-expand', align: 'start' },
                      { text: 'Date échéance', value: 'dateEcheance', align: 'center' },
                  ]
                : [
                      { text: '', value: 'data-table-expand', align: 'start' },
                      { text: 'Numéro', value: 'code' },
                      { text: "Date d'émission", value: 'date', align: 'center' },
                      { text: 'Date échéance', value: 'dateEcheance', align: 'center' },
                  ]
            if (this.$database.account.roleEnum != RoleEnum.Client) headers.push({ text: 'Montant', value: 'amount', align: 'end' })

            return headers
        },
        headersReeditionFacture() {
            const headers = this.isMobileDevice()
                ? [
                      { text: 'Demandeur', value: 'demandeur' },
                      { text: 'Codes factures', value: 'codesFactures' },
                      { text: 'Date', value: 'date' },
                  ]
                : [
                      { text: 'Demandeur', value: 'demandeur' },
                      { text: 'Client', value: 'codeClient' },
                      { text: 'Codes factures', value: 'codesFactures' },
                      { text: 'Date', value: 'date' },
                      { text: 'Statut', value: 'statut' },
                  ]
            if (this.$database.account.roleEnum == RoleEnum.SuperAdmin) {
                headers.push({ text: 'Modification du statut', value: 'lastUserTraitement' })
                headers.push({ text: 'Dernier traitement', value: 'dateLastTraitement' })
            }
            return headers
        },
        formatDate(date: Date) {
            return new Date(date).toLocaleDateString('fr-FR')
        },
        formatListe(values: Array<string>) {
            return values.join(', ')
        },
        modalDemandeReeditionFacture() {
            this.demandeReeditionEmailDestinataire = this.$database.account.email
            this.demandeReeditionDescription = ''
            if (this.$database.account.roleEnum == RoleEnum.Client) this.demandeReeditionFacture()
            else this.openReedition()
        },
        formatStatutDemandeReedition(demande: DemandeFacturation) {
            return TraitementReeditionFacture_Statut_ToText(demande.statut)
        },
        colorStatutDemandeReedition(demande: DemandeFacturation) {
            return demande.statut == TraitementReeditionFacture_Statut.EnAttenteDeTraitement ? 'info' : demande.statut == TraitementReeditionFacture_Statut.EnCoursDeTraitement ? 'warning' : 'success'
        },
    },
})
